export default "__VITE_ASSET__CfdNqD4C__"